<p-panel header="{{'PLAGA.LBL_PLAGA' | translate}}">
  <div class="grid" *ngIf="carInformacionInicial">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{'LBL_CONSULTANDO' | translate }}</span>
    </div>
  </div>
  <div *ngIf="!carInformacionInicial">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">

        <div class="grid form-group">
          <div class="col-12 md:col-3 lg:col-3 md:col-offset-2 lg:col-offset-2">
            <div class="div-form">
              <label>{{'LBL_CODIGO' | translate}}: </label>
              <label class="falso-combo-texto"><b>{{ plaga.codigo }}</b></label>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>{{'PLAGA.LBL_PLAGA' | translate}}: </label>
              <label class="falso-combo-texto"><b>{{ plaga.nombre }}</b></label>
            </div>
          </div>


          <div class="col-12 md:col-2 lg:col-2">
            <div class="div-form">
              <p-checkbox [(ngModel)]="plaga.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              <label>{{'LBL_HABILITADO' | translate}}</label>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <h2>{{'PLAGA.LBL_PRODCOMER' | translate}}</h2>
      </div>
    </div>


    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnasControlPlaga" [loading]="carTabla" #dt
                 [value]="lisPlagaProductoComercial" selectionMode="single" dataKey="idPlagaProductoAgricola"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td class="table-break">{{row.tipoControlPlaga}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 ">
        <h2>{{'PLAGA.LBL_PRODAGRICOLA' | translate}}</h2>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnasProducto" [loading]="carTabla" #dt
                 [value]="lisPlagaProducto" selectionMode="single" dataKey="idPlagaProductoAgricola"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td class="table-break">{{row.productoAgricola}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </div>
</p-panel>
